import React from 'react'

// Components
import ProfileCard from '../../../../components/ProfileCard'

// hooks
import { useBranding } from '../../../../hooks/branding'

// Styles
import styles from './YourTeam.module.scss'

const YourTeam = () => {
  const {
    // cp
    customerType,
    customerFirstName,
    customerLastName,
    customerStatement,
    customerNMLS,
    customerPhone,
    customerEmail,
    customerPhotoUri,
    customerCorporateName,
    customerCorporatePhone,
    // sponsor
    isSponsorPresent,
    sponsorType,
    sponsorFirstName,
    sponsorLastName,
    sponsorStatement,
    sponsorNMLS,
    sponsorPhone,
    sponsorEmail,
    sponsorPhotoUri,
    sponsorCorporateName,
    sponsorCorporatePhone,
    //branding
    loClientsHelped,
    loYearsInIndustry,
  } = useBranding()

  const customerProfile = {
    type: customerType,
    firstName: customerFirstName,
    lastName: customerLastName,
    brandingStatement: customerStatement,
    nmls: customerNMLS,
    phone: customerPhone,
    email: customerEmail,
    photo: customerPhotoUri,
    corporateProfileName: customerCorporateName,
    corporateProfilePhone: customerCorporatePhone,
  }

  const sponsorProfile = {
    type: sponsorType,
    firstName: sponsorFirstName,
    lastName: sponsorLastName,
    brandingStatement: sponsorStatement,
    nmls: sponsorNMLS,
    phone: sponsorPhone,
    email: sponsorEmail,
    photo: sponsorPhotoUri,
    corporateProfileName: sponsorCorporateName,
    corporateProfilePhone: sponsorCorporatePhone,
  }

  const branding = {
    loClientsHelped,
    loYearsInIndustry,
  }

  return (
    <div className={styles.yourTeam}>
      <ProfileCard
        profile={customerProfile}
        isSponsorPresent={isSponsorPresent}
        branding={branding}
      />
      {isSponsorPresent && (
        <ProfileCard
          profile={sponsorProfile}
          isSponsorPresent={isSponsorPresent}
          sponsorForFirstName={customerFirstName}
          branding={branding}
        />
      )}
    </div>
  )
}

export default YourTeam
